// usePathQuestions.js
import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchContentGroupByName } from '../../api/contentGroups';

export const usePathQuestions = () => {
  const dispatch = useDispatch();
  const questionsLibrary = useSelector(state => state.contentGroups.groups['portfolioPathQuestions']);
  const status = useSelector(state => state.contentGroups.status['portfolioPathQuestions']);
  const error = useSelector(state => state.contentGroups.error['portfolioPathQuestions']);

  // Fetch the library of questions
  useEffect(() => {
    if (!questionsLibrary && status !== 'loading') {
      dispatch(fetchContentGroupByName('portfolioPathQuestions'));
    }
  }, [dispatch, questionsLibrary, status]);

  // Get specific questions by entry IDs
  const getQuestionsByIds = (entryIds) => {
    if (!questionsLibrary || !Array.isArray(entryIds)) {
      return [];
    }

    return entryIds
      .map(id => questionsLibrary.find(q => q.sys.id === id))
      .filter(Boolean);
  };

  return {
    questionsLibrary,
    getQuestionsByIds,
    isLoading: status === 'loading',
    error
  };
};